/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { Suspense, lazy } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import canUseDom from "../../../../utils/can-use-dom";
import { updateBodyScroll } from "../../../utils.js";
import loadingIcon from "../../../../assets/icons/loading.svg";
import "./image-lightbox.module.css";
import "./image-lightbox.scss";
import { SvgHandler } from "../../svg-handler/svg-handler";

const Lightbox = lazy(() => import("react-image-lightbox"));

class ImageLightbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      photoIndex: 0
    };
  }

  onClickHandler = index => {
    this.setState({
      isOpen: true,
      photoIndex: index
    });
    updateBodyScroll(true);
  };

  componentWillUnmount() {
    updateBodyScroll(false);
  }

  onMoveNext = imageUrlListLength => {
    this.setState({
      photoIndex: (this.state.photoIndex + 1) % imageUrlListLength
    });
  };

  onMovePrev = imageUrlListLength => {
    this.setState({
      photoIndex: (this.state.photoIndex + imageUrlListLength - 1) % imageUrlListLength
    });
  };

  onClose = () => {
    this.setState({
      isOpen: false,
      photoIndex: 0
    });
    updateBodyScroll(false);
  };

  render() {
    const { isOpen, photoIndex } = this.state;
    const { imageSlug, cdn, template, element = {} } = this.props;
    const onClickKey = imageSlug ? "onClick" : "onClickHandler";
    let imageUrlList = [];
    if (!imageSlug) {
      imageUrlList = get(element, ["story-elements"], []).map(image => `//${cdn}/${image["image-s3-key"]}`);
    }
    const imageUrlListLength = imageUrlList.length;
    const lightboxProps = imageSlug
      ? {
          mainSrc: `//${cdn}/${imageSlug}`
        }
      : {
          mainSrc: imageUrlList[photoIndex],
          nextSrc: imageUrlList[(photoIndex + 1) % imageUrlListLength],
          prevSrc: imageUrlList[(photoIndex + imageUrlListLength - 1) % imageUrlListLength],
          onMoveNextRequest: () => this.onMoveNext(imageUrlListLength),
          onMovePrevRequest: () => this.onMovePrev(imageUrlListLength)
        };

    return (
      <React.Fragment>
        {React.createElement(template, { [onClickKey]: this.onClickHandler, ...this.props })}
        {isOpen && canUseDom ? (
          <Suspense fallback={<SvgHandler clazzName="loader" xlinkHref={loadingIcon} />}>
            <Lightbox wrapperClassName="lightbox-custom-styles" onCloseRequest={this.onClose} {...lightboxProps} />
          </Suspense>
        ) : null}
      </React.Fragment>
    );
  }
}

ImageLightbox.propTypes = {
  imageSlug: PropTypes.string,
  cdn: PropTypes.string,
  template: PropTypes.func,
  element: PropTypes.object
};

export { ImageLightbox };
